import personalinfo from './personalInfo.vue'

personalinfo.install = function(Vue){
	Vue.component('personalinfo',personalinfo);
}

export default personalinfo



// WEBPACK FOOTER //
// ./src/components/personalInfo/index.js